import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const a = i((o, l) => /* @__PURE__ */ e.jsx(
  t,
  {
    ref: l,
    ...o,
    image: (r) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...r,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM13.753 20h-1.84v-8.402h1.84zm4.887 0h-1.975l-2.22-6.182h1.886l1.336 4.354 1.277-4.354h1.835z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
a.displayName = "IvermectinIcon";
export {
  a as IvermectinIcon,
  a as default
};
//# sourceMappingURL=index.js.map
